<template>
  <v-simple-table :dense="true" :fixed-header="true">
    <template v-slot:default>
      <thead></thead>
      <tbody>
        <template v-if="showHeader == true">
          <tr>
            <td class="text-xs-left" :width="width.toString() + '%'">
              <h3>{{ $t("advanced.headers." + unitName) }}</h3>
            </td>
          </tr>
        </template>

        <template v-if="filter.includes('U') === true">
          <template v-if="unitName == 'inverter'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.uDC')" :value="unitState.uDC" unit="V" :widthRatio="width"></AdvancedCore>
          </template>
          <template v-if="unitName == 'dab'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.dc.u')" :value="unitState.dc.u" unit="V" :widthRatio="width"></AdvancedCore>
          </template>
          <template v-if="unitName == 'pv' || unitName == 'mppt'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.uOut')" :value="unitState.uOut" unit="V" :widthRatio="width"></AdvancedCore>
          </template>
        </template>

        <template v-if="filter.includes('I') === true">
          <template v-if="unitName == 'inverter'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.iDC')" :value="unitState.iDC" unit="A" :widthRatio="width"></AdvancedCore>
          </template>
          <template v-if="unitName == 'dab'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.dc.i')" :value="unitState.dc.i" unit="A" :widthRatio="width"></AdvancedCore>
          </template>
          <template v-if="unitName == 'pv' || unitName == 'mppt'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.iOut')" :value="unitState.iOut" unit="A" :widthRatio="width"></AdvancedCore>
          </template>
        </template>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import AdvancedCore from "./AdvancedCore.vue";

export default {
  name: "AdvancedDC",
  components: {
    AdvancedCore,
  },
  props: {
    unitState: {
      type: Object,
      require: false,
    },
    unitName: {
      type: String,
      require: true,
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
    filter: {
      type: Array,
      required: false,
      default: () => ["I", "U", "OTHERS"],
    },
    width: {
      type: Number,
      require: false,
      default: 50,
    },
    data() {
      return {};
    },
  },
};
</script>
